import { createContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  BASE_URL,
  EDIT_PROFILE,
  PATIENTPROFILE,
  VEIWPROFILE,
  GET_CONSULTATION_LISTING,
  GET_REFERRAL_LIST,
  GET_DOCTOR_LIST,
  GET_CENTER,
  GET_TEST,
  GET_PATIENTS,
  CALL_RATE,
  GET_TRANSACTIONS,
} from "../API";
import axios from "axios";
import { toast } from "react-toastify";

export const ProfileContext = createContext();
export const ProfileProvider = ({ children }) => {
  const [profile, setProfile] = useState({});
  const navigate = useNavigate();

  const TOKEN = localStorage.getItem("token");
  const headers = { token: TOKEN };

  const [currentImage, setCurrentImage] = useState(null);
  const [personalInfo, setPersonalInfo] = useState(null);
  const [pagination, setpagination] = useState({});
  const [pendingConsultation, setPendingConsultation] = useState([]);
  const [approvedConsultation, setApprovedConsultation] = useState([]);
  const [referralData, setReferralData] = useState([]);
  const [allDocotors, setAllDocotors] = useState([]);
  const [doctorPagination, setDoctorPagination] = useState({});
  const [diagnosticsCenter, setDiagnosticsCenter] = useState([]);
  const [diagnosticsCenterPagination, setDiagnosticsCenterPagination] = useState({});
  const [diagnosticsTest, setDiagnosticsTest] = useState([]);
  const [diagnosticsTestPagination, setDiagnosticsTestPagination] = useState({});
  const [patientList, setPatientList] = useState([]);
  const [callHistory, setCallHistory] = useState([]);
  const [callHistoryPagination, setCallHistoryPagination] = useState({});
  const [payments, setPayments] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [chartData, setChartData] = useState([]);
  const [modalChartData, setModalChartData] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (TOKEN) {
      viewProfile();
      getConsultation();
      getRefferal();
      getAllDoctors();
      getCenters(1);
      getTests(1, "", "");
      fetchData(1)
    }
  }, [TOKEN])

  useEffect(() => { if (personalInfo?.role === "SUB-ADMIN") { getPatients() } }, [personalInfo?.role]);

  const fetchData = async (page) => {
    try {
      const res = await axios.get(`${BASE_URL}${PATIENTPROFILE}?page=${page}`, { headers });
      if (res.data.status) {
        setProfile(res.data.data?.data || []);
        setpagination(res.data.data?.pagination || { currentPage: page, totalPages: 1, totalCount: 0, limit: 10 });
      } else {
        toast.error(res.data.message || "Failed to fetch patient records");
      }
    } catch (error) {
      const errMsg = error?.response?.data?.error_description || "Error fetching patient records";
      console.error("Error fetching data:", error);
      toast.error(errMsg);
    }
  };

  const editProfile = async (data) => {
    data.file = currentImage;
    data.language = "ENGLISH";
    try {
      const response = await axios.post(BASE_URL + EDIT_PROFILE, data, { headers: { token: TOKEN, "Content-Type": "multipart/form-data" } });

      if (response.data.status) {
        toast.success("Profile updated successfully");
        navigate("/profile");
      }
      else { toast.error(response.data.message || "Failed to update profile") }
    }
    catch (error) { toast.error("Something went wrong") }
  };

  const viewProfile = async () => {
    try {
      const resp = await axios.get(BASE_URL + VEIWPROFILE, { headers });
      if (resp.status === 200) { setPersonalInfo(resp?.data?.data[0]) }
    }
    catch (error) { console.log(error) }
  };

  const getAllDoctors = async (page) => {
    setIsLoading(true);
    try {
      const response = await axios.get(BASE_URL + GET_DOCTOR_LIST, { headers });
      const json = response.data;
      if (json.code === 200 && json.status === true) {
        setAllDocotors(json.data.data);
        setDoctorPagination(json.data?.pagination || { currentPage: page, totalPages: 1, totalCount: 0, limit: 10 });
      }
      else { console.log("Error fetching products"); }
    } catch (err) {
      console.error("Best season product fetch error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const getConsultation = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(BASE_URL + GET_CONSULTATION_LISTING, { headers });
      const json = response.data;
      if (json.code === 200 && json.status === true) {
        const data = json.data
        setPendingConsultation(data.pendingConsultation);
        setApprovedConsultation(data.approvedConsultation);
      }
      else { console.log("Error fetching products"); }
    }
    catch (err) { console.error("Best season product fetch error:", err); }
    finally { setIsLoading(false); }
  };

  const getRefferal = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(BASE_URL + GET_REFERRAL_LIST, { headers });
      if (response.data.code == 200 && response.data.status === true) {
        const data = response.data.data
        setReferralData(data)
      }
      else { console.log("Error fetching products"); }
    }
    catch (err) { console.error("Best season product fetch error:", err); }
    finally { setIsLoading(false); }
  };

  const getCenters = async (page) => {
    setIsLoading(true);

    try {
      const response = await axios.get(BASE_URL + GET_CENTER + '?page=' + page, { headers });
      const json = response.data;
      if (json.code === 200 && json.status === true) {
        setDiagnosticsCenter(json?.data?.data);
        setDiagnosticsCenterPagination(json.data?.pagination || { currentPage: page, totalPages: 1, totalCount: 0, limit: 10 });
      }
      else { console.log("Error fetching products"); }
    }
    catch (err) { console.error("Best season product fetch error:", err); }
    finally { setIsLoading(false); }
  };

  const getTests = async (page, search, category) => {
    setIsLoading(true);
    try {
      const response = await axios.get(BASE_URL + GET_TEST, { headers, params: { page, search, category } });
      const json = response.data;
      if (json.code === 200 && json.status === true) {
        setDiagnosticsTest(json?.data?.data)
        setDiagnosticsTestPagination(json?.data?.pagination || { currentPage: page, totalPages: 1, totalCount: 0, limit: 10 })
      }
      else { console.log("Error fetching products"); }
    }
    catch (err) { console.error("Best season product fetch error:", err); }
    finally { setIsLoading(false); }
  };

  const getPatients = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(BASE_URL + GET_PATIENTS, { headers });
      if (response.data.code == 200 && response.data.status === true) {
        setPatientList(response.data.data)
      }
      else { console.log("Error fetching products"); }
    }
    catch (err) { console.error("Best season product fetch error:", err); }
    finally { setIsLoading(false); }
  };

  const getCallHistory = async (page, filter = 'all') => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/get-hygen-call-history?page=${page}&filter=${filter}`, { headers });
      const json = response.data;
      if (json.code === 200 && json.status === true) {
        setCallHistory(json.data.data);
        setCallHistoryPagination(json.data.pagination || { currentPage: page, totalPages: 1, totalCount: 0, limit: 10 });
      }
      else { console.log("Error fetching call history"); }
    }
    catch (err) { console.error("Call history fetch error:", err); }
    finally { setIsLoading(false); }
  };

  const sendInvoice = async (data) => {
    setIsLoading(true);
    try {
      const response = await axios.post(`${BASE_URL}/send-invoice`, data, { headers });
      if (response.data.status) { toast.success("Invoice sent successfully"); return true; }
      else { toast.error(response.data.message || "Failed to send invoice"); return false; }
    }
    catch (err) { toast.error(err?.response?.data?.error_description || "Something went wrong"); return false; }
    finally { setIsLoading(false); }
  };

  const markAsPaid = async (invoiceId) => {
    setIsLoading(true);
    try {
      const response = await axios.patch(`${BASE_URL}/mark-invoice-paid`, { invoice_id: invoiceId }, { headers });
      if (response.data.status) { toast.success("Payment recorded successfully"); return true }
      else { toast.error(response.data.message || "Failed to mark as paid"); return false }
    }
    catch (err) { toast.error(err?.response?.data?.error_description || "Something went wrong"); return false }
    finally { setIsLoading(false) }
  };

  const getCallRateData = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(BASE_URL + CALL_RATE, { headers });
      const json = response.data;
      if (json.status === true) {
        return json.data;
      }
      return null;
    }
    catch (err) { console.error("Call rate fetch error:", err); return null; }
    finally { setIsLoading(false); }
  };

  const updateCallRateData = async (payload) => {
    setIsLoading(true);

    try {
      const response = await axios.put(BASE_URL + CALL_RATE, payload, { headers });
      if (response.data.status) { toast.success("Settings updated successfully"); return true; }
    }
    catch (err) {
      toast.error(err?.response?.data?.error_description || err?.response?.data?.message || "Something went wrong");
      return false;
    }
    finally { setIsLoading(false) }
  };

  const fetchTransactions = async (page = null, rowsPerPage = null, filter, userId) => {
    setIsLoading(true);
    try {
      const response = await axios.get(BASE_URL + GET_TRANSACTIONS,
        { params: { page: page + 1, limit: rowsPerPage, filter, userId }, headers }
      );
      if (response.data.status) {
        if (userId) { setModalChartData(response.data.data.chartData) }
        else {
          const mappedData = response.data.data.data.map((item) => {
            return {
              _id: item.user_id,
              patient: item?.full_name || "Unknown",
              email: item?.email || "Unknown",
              lastTransaction: item.lastTransaction,
              amount: item.totalAmount || 0,
              transactionCount: item.transactionCount,
            };
          });
          setPayments(mappedData);
          setTotalRecords(response.data.data.pagination.totalCount);
          setChartData(response.data.data.chartData);
        }
      }
    } catch (error) {
      console.error("Error fetching transactions:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const resetProfileContext = () => {
    setProfile({});
    setCurrentImage(null);
    setPersonalInfo(null);
    setpagination({});
    setPendingConsultation([]);
    setApprovedConsultation([]);
    setReferralData([]);
    setAllDocotors([]);
    setDoctorPagination({});
    setDiagnosticsCenter([]);
    setDiagnosticsCenterPagination({});
    setDiagnosticsTest([]);
    setDiagnosticsTestPagination({});
    setPatientList([]);
    setCallHistory([]);
    setCallHistoryPagination({});
    setPayments([]);
    setTotalRecords(0);
    setChartData([]);
    setModalChartData([]);
    setIsLoading(false);
  };

  return (
    <ProfileContext.Provider
      value={{
        headers, navigate,
        profile, setProfile,
        isLoading, setIsLoading,
        fetchData,
        editProfile, personalInfo, setPersonalInfo,
        viewProfile, pagination, setpagination,
        getConsultation,
        pendingConsultation,
        approvedConsultation,
        getRefferal, referralData,
        allDocotors, doctorPagination, setDoctorPagination, getAllDoctors,
        getCenters, diagnosticsCenter, diagnosticsCenterPagination,
        getTests, diagnosticsTest, diagnosticsTestPagination,
        patientList, setPatientList,
        getCallHistory, callHistory, callHistoryPagination,
        sendInvoice, markAsPaid,
        getCallRateData, updateCallRateData,
        payments, totalRecords, chartData, modalChartData, setPayments, setTotalRecords, setChartData, setModalChartData,
        fetchTransactions, resetProfileContext
      }}
    >
      {children}
    </ProfileContext.Provider>
  );
};
